import { TextSizeType } from '../types';
import { TextSizeProps } from '../properties';

export function getTextSize(size?: TextSizeType) {
  if (!size) return '';
  return TextSizeProps[size];
}
